import styled from 'styled-components'

import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'

import type { TrackingWallet } from '@root/entities/wallet-tracking'

type TrackingWalletCellProps = {
  wallet: TrackingWallet.TrackingWallet
}

export const TrackingWalletCell: React.FC<TrackingWalletCellProps> = ({
  wallet,
}) => {
  return (
    <Root>
      <EmojiBox>{wallet.emoji}</EmojiBox>
      <Label>{wallet.label}</Label>
      <Address walletAddress={wallet.walletAddress} withCopy />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
`

const EmojiBox = styled.div`
  display: flex;
  width: 22px;
  height: 22px;
  padding: 3px 5px;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  background: var(--appearance-1, #000);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const Label = styled.div`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const Address = styled(WalletAddressTruncated)`
  color: var(--text-11);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`
